import React from "react";
import smallLogo from "../../assets/smallBlue.png";

const Loading = () => (
  <div className="loading">
    <img className="drop" src={smallLogo} alt="eflogo" />
  </div>
);

export default Loading;
